module.exports = __webpack_public_path__ + "img/君子兰漆.f14c8525.png";